
export class QuestionTagEntity {
  corpId: number;
  id: number;
  alias: string;
  name: string;
  showInCampus: boolean;
  showInMagnament: boolean;


  constructor(id: number) {
    this.id = id;
  }
}
